define(
    'viewmodels/secured/explorer/navigation/menu',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "services/service.documents"
    ],
    function(ctx, ViewModel, documentsService) {
        var vm = new ViewModel(
        {
            items: ko.observable([]),
            //itemSelectedAfter: function (widget, isSelected, hasSelected, wasActive) { },
            currentItem: ko.observable()
        });

        vm.Item = function (isDropDown, id) {
            var self = this;

            self.id = id;
            self.isActive = ko.observable(false);
            self.isSelected = ko.observable(false);
            self.isBusy = ko.computed(function () {
                return self.isSelected() && documentsService.busyTracker.isBusy();
            });

            self.isDropDown = isDropDown;
            self.widget = null;
        };

        vm.itemSelected = function (clickedMenuItem) {
            var isSelected = !clickedMenuItem.isDropDown || !clickedMenuItem.isSelected(); // if closing a drop down, it is no longer selected.
            var wasActive = clickedMenuItem.isActive();
            var hasSelected = false;

            _.each(vm.items(), function (menuItem) {
                hasSelected = hasSelected || menuItem.isSelected();
                menuItem.isActive(false);
                menuItem.isSelected(false);
            });

            clickedMenuItem.isSelected(isSelected);
            clickedMenuItem.isActive(true);
            
            vm.currentItem(clickedMenuItem);
            ctx.menu = vm;
            //vm.itemSelectedAfter(clickedMenuItem.widget, isSelected, hasSelected, wasActive);

            //console.warn("clickedMenuItem");
            //console.warn(clickedMenuItem);
            
            if (clickedMenuItem.id == "library") {
                sessionStorage.__url_type = clickedMenuItem.id;
                sessionStorage.__url = window.location.origin + '/#explorer/' + sessionStorage.__url_type;
                window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
            } else {
                sessionStorage.__url_type = "";
                sessionStorage.__url_libraryId = "";
                sessionStorage.__url_folderId = "";
                sessionStorage.__url_documentId = "";

                sessionStorage.__url = window.location.origin + '/#explorer/';
                window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
            }
            
        };

        return vm;
    });
